const LOCAL_OPEN_WORK_MAP_METABASE_PATH = '/__local_open_work_metabase';

export const isOpenWorkMapLocalReviewEnabled = (
  isDev = import.meta.env.DEV,
  flag = import.meta.env.VITE_OPEN_WORK_MAP_LOCAL_METABASE,
) => isDev && flag === 'true';

export const openWorkMapCardUrl = (
  cardId: number,
  localReviewEnabled = isOpenWorkMapLocalReviewEnabled(),
  origin = globalThis.location?.origin,
) => {
  if (!localReviewEnabled) return `/cube/card/${cardId}/query/json`;
  if (!origin) throw new Error('Browser origin is required for local Open Work Map review');

  return `${origin}${LOCAL_OPEN_WORK_MAP_METABASE_PATH}/card/${cardId}/query/json`;
};
